<div class="full-screen d-flex align-items-center pt-30 pb-30 pt-lg-0 pb-lg-0">
    <div class="container-fluid">
        <div class="row justify-content-lg-start justify-content-center">
            <div class="col-lg-2 d-none d-lg-block"></div>
            <div class="col-12 col-lg-10">
                <div class="brk-form brk-form-strict maxw-570 mx-auto mx-lg-0 text-center text-lg-left"
                    data-brk-library="component__form">

                    <h1
                        class="font__family-montserrat font__weight-bold font__size-42 line__height-42 mt-0 mb-35 text-center text-lg-left">
                        Não foi possível conectar ao servidor</h1>
                    <div class="connection-error-illustration mb-30 text-center text-lg-left" aria-hidden="true">
                        <svg viewBox="0 0 420 250" role="img" class="connection-error-illustration__svg">
                            <defs>
                                <linearGradient id="bgGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#f7fbf4" />
                                    <stop offset="100%" stop-color="#e6f0df" />
                                </linearGradient>

                                <linearGradient id="groundGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#dbe8d3" />
                                    <stop offset="100%" stop-color="#bfd2b2" />
                                </linearGradient>

                                <clipPath id="sceneClip">
                                    <rect x="0" y="0" width="420" height="250" rx="24" />
                                </clipPath>
                            </defs>

                            <g clip-path="url(#sceneClip)">
                                <!-- Background -->
                                <rect width="420" height="250" rx="24" fill="url(#bgGradient)" />

                                <!-- Ground -->
                                <path d="M0 165C90 145 160 150 230 160C300 170 360 160 420 150V250H0Z"
                                    fill="url(#groundGradient)" />

                                <!-- Base Y para alinhamento -->
                                <!-- Todos os elementos usam centerY = 125 -->

                                <!-- CLIENT -->
                                <rect x="70" y="95" width="90" height="60" rx="12" fill="#f6fbf3" stroke="#8da980"
                                    stroke-width="3" />
                                <rect x="85" y="110" width="60" height="8" rx="4" fill="#7c9a72" />
                                <rect x="85" y="125" width="45" height="8" rx="4" fill="#7c9a72" />

                                <!-- SERVER -->
                                <rect x="260" y="95" width="90" height="60" rx="12" fill="#f6fbf3" stroke="#8da980"
                                    stroke-width="3" />
                                <circle cx="305" cy="110" r="5" fill="#7c9a72" />
                                <circle cx="305" cy="125" r="5" fill="#7c9a72" />
                                <circle cx="305" cy="140" r="5" fill="#7c9a72" />

                                <!-- CONNECTION (tracejada, alinhada) -->
                                <line x1="160" y1="125" x2="200" y2="125" stroke="#7c9a72" stroke-width="4"
                                    stroke-linecap="round" stroke-dasharray="6 6" />

                                <!-- ERROR CIRCLE CENTRAL -->
                                <circle cx="210" cy="125" r="20" fill="#fff5f5" stroke="#e57373" stroke-width="3" />

                                <!-- X -->
                                <line x1="200" y1="115" x2="220" y2="135" stroke="#e57373" stroke-width="3"
                                    stroke-linecap="round" />
                                <line x1="220" y1="115" x2="200" y2="135" stroke="#e57373" stroke-width="3"
                                    stroke-linecap="round" />

                                <!-- DETALHE: pequena quebra na linha 
                                <line x1="190" y1="125" x2="230" y2="125" stroke="#e57373" stroke-width="3"
                                    stroke-linecap="round" stroke-dasharray="2 6" />-->

                            </g>
                        </svg>
                    </div>
                    <div class="alert alert-clean fade alert-warning text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show"
                        role="alert" data-brk-library="component__alert">
                        <i class="start-icon fas fa-wifi"></i>
                        <strong class="font__weight-semibold">Falha de comunicação com o servidor.</strong>
                        Verifique sua conexão de rede e tente acessar novamente em instantes. Se continuar indisponível,
                        entre em contato com o suporte.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>